import React from "react";

const networks = [
  {
    title: "Mumbai Outstations",
    img: "/images/network/Mumbai-Outstations.png",
  },
  {
    title: "Mumbai ↔ Pune",
    img: "/images/network/Mumbai--Pune---Mumbai.png",
  },
  {
    title: "Pune",
    img: "/images/network/pune.png",
  },
  {
    title: "Nashik",
    img: "/images/network/nashik.png",
  },
  {
    title: "Kolhapur",
    img: "/images/network/kolhapur.png",
  },
    {
    title: "Lonavala",
    img: "/images/network/Lonavala.webp",
  },
  {
    title: "Goa",
    img: "/images/network/goa.png",
  },
  {
    title: "Sambhaji Nagar (Aurangabad)",
    img: "/images/network/sambhaji-nagar.png",
  },
  {
    title: "Satara",
    img: "/images/network/satara.jpg",
  },
  {
    title: "Alibaug",
    img: "/images/network/alibag.jpg",
  },
  {
    title: "Ratnagiri",
    img: "/images/network/ratnagiri.jpg",
  },
  {
    title: "Lavasa",
    img: "/images/network/lavasa.jpg",
  },
  {
    title: "Mahabaleshwar",
    img: "/images/network/mahabaleshwar.jpg",
  },
  {
    title: "Shirdi",
    img: "/images/network/shirdi.jpg",
  },
    {
    title: "Banglore",
    img: "/images/network/banglore.jpg",
  },
  {
    title: "Pan India Service",
    img: "/images/network/pan-india.png",
  },
];

const Network = () => {
  return (
<>
 <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">Our Network</h1>
          </div>
        </div>
      </div>


    <section className="network-section">
      <div className="container">

        {/* Header */}
        <div className="network-header">
          <h2>
            Our <span>Network</span>
          </h2>
          <p>
            We provide trusted Royal Route Cab service across major cities in India
          </p>
        </div>

        {/* Grid */}
        <div className="row">
          {networks.map((item, index) => (
            <div className="col-md-3 col-sm-6 mb-4" key={index}>
              
              <div className="network-card">

                <div className="network-img">
                  <img src={item.img} alt={item.title} />
                </div>

                <div className="network-content">
                  <h4>{item.title}</h4>
                </div>

              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
</>
  );
};

export default Network;